import { useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { ReaderInsight } from '../shared'

export const MomBooksInsight = () => {
  const { colors } = useTheme()
  const theme = useStats((s) => s.theme)
  const insight = useStats((s) => s.stats?.mom_books_read?.insight)

  return !!insight ? (
    <ReaderInsight
      data-testid="mom-books-insight"
      backgroundColor={theme.insightBg || theme.bg200}
      text={insight}
      color={colors.uiWhite50}
    />
  ) : null
}
